import Recorder from "./Recorder";

function FeedbackApp(props) {
    return (
        <Recorder {...props} />
    )
}

export default FeedbackApp;